import { render, staticRenderFns } from "./MarryState.vue?vue&type=template&id=15ccb518&scoped=true&"
import script from "./MarryState.vue?vue&type=script&lang=js&"
export * from "./MarryState.vue?vue&type=script&lang=js&"
import style0 from "./MarryState.vue?vue&type=style&index=0&id=15ccb518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ccb518",
  null
  
)

export default component.exports